import { render } from "./ContactEditor.vue?vue&type=template&id=94346dbe"
import script from "./ContactEditor.vue?vue&type=script&lang=js"
export * from "./ContactEditor.vue?vue&type=script&lang=js"

import "./ContactEditor.vue?vue&type=style&index=0&id=94346dbe&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__